import { render } from "./OfficeComponent.vue?vue&type=template&id=028fe104"
import script from "./OfficeComponent.vue?vue&type=script&lang=js"
export * from "./OfficeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__